var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36364 2.36364C6.36364 2.16281 6.20083 2 6 2C5.79917 2 5.63636 2.16281 5.63636 2.36364V5.63636H2.36364C2.16281 5.63636 2 5.79917 2 6C2 6.20083 2.16281 6.36364 2.36364 6.36364H5.63636V9.63636C5.63636 9.83719 5.79917 10 6 10C6.20083 10 6.36364 9.83719 6.36364 9.63636V6.36364H9.63636C9.83719 6.36364 10 6.20083 10 6C10 5.79917 9.83719 5.63636 9.63636 5.63636H6.36364V2.36364Z",
    fill: "currentColor",
    fillOpacity: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80258 4.80258C4.66058 4.94459 4.43033 4.94459 4.28833 4.80258L3.19742 3.71167C3.05541 3.56967 3.05541 3.33942 3.19742 3.19741C3.33943 3.05541 3.56967 3.05541 3.71168 3.19742L4.80258 4.28832C4.94459 4.43033 4.94459 4.66058 4.80258 4.80258Z",
    fill: "currentColor",
    fillOpacity: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80258 3.71168C8.94459 3.56967 8.94459 3.33942 8.80259 3.19742C8.66058 3.05541 8.43033 3.05541 8.28833 3.19742L7.19742 4.28832C7.05541 4.43033 7.05541 4.66057 7.19742 4.80258C7.33943 4.94459 7.56967 4.94459 7.71168 4.80258L8.80258 3.71168Z",
    fill: "currentColor",
    fillOpacity: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80258 7.19742C4.94459 7.33942 4.94459 7.56967 4.80258 7.71168L3.71168 8.80258C3.56967 8.94459 3.33943 8.94459 3.19742 8.80258C3.05541 8.66057 3.05541 8.43033 3.19742 8.28832L4.28833 7.19742C4.43033 7.05541 4.66058 7.05541 4.80258 7.19742Z",
    fill: "currentColor",
    fillOpacity: "inherit"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28833 8.80258C8.43033 8.94459 8.66058 8.94459 8.80258 8.80258C8.94459 8.66058 8.94459 8.43033 8.80259 8.28832L7.71168 7.19742C7.56967 7.05541 7.33943 7.05541 7.19742 7.19741C7.05541 7.33942 7.05541 7.56967 7.19742 7.71167L8.28833 8.80258Z",
    fill: "currentColor",
    fillOpacity: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.1575c25140886265c725900c2c665560.svg";
export { ForwardRef as ReactComponent };